import { HeadlineContent } from '@/types';

export const othersTechnologies: HeadlineContent = {
  before: 'Other',
  highlight: 'Technologies'
};
